export const SelectPlayer1Stats = (state) => state.ChartReducer.player1_stats;
export const SelectPlayer2Stats = (state) => state.ChartReducer.player2_stats;
